import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactGA from 'react-ga'
import { Route } from 'react-router-dom'
import Cookies from 'js-cookie'
import { connect } from 'react-redux'

class GoogleAnalytics extends Component {
    componentDidMount() {
        this.logPageChange(this.props.location.pathname, this.props.location.search)
    }

    componentDidUpdate({ location: prevLocation }) {
        const {
            location: { pathname, search },
        } = this.props
        const isDifferentPathname = pathname !== prevLocation.pathname
        const isDifferentSearch = search !== prevLocation.search

        if (isDifferentPathname || isDifferentSearch) {
            this.logPageChange(pathname, search)
        }
    }

    logPageChange(pathname, search = '') {
        const page = pathname + search
        const { location } = window
        const obj = {
            page,
            location: `${location.origin}${page}`,
            ...this.props.options,
        }

        const { userDetails } = this.props
        if (userDetails && userDetails.cid) {
            obj.dimension1 = userDetails.cid
        } else {
            const ga = Cookies.get('_ga')
            if (typeof ga !== 'undefined') {
                obj.dimension1 = ga
            }
        }
        ReactGA.set(obj)
        ReactGA.pageview(page)
    }

    render() {
        return null
    }
}

GoogleAnalytics.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string,
        search: PropTypes.string,
    }).isRequired,
    options: PropTypes.object,
}

const RouteTracker = () => (
    <Route component={connect(state => ({ userDetails: state.user_details }), null)(GoogleAnalytics)} />
)

const init = (options = {}) => {
    let trackingCode = null

    switch (process.env.REACT_APP_BACKEND_URL) {
        case 'https://api.dev.interacty.me':
            // dev
            trackingCode = 'UA-183229288-1'
            break
        case 'https://api.stage.interacty.me':
            // stage
            break
        case 'https://api.interacty.me':
            // prod
            trackingCode = 'UA-156949074-1'
            break
        default:
            break
    }

    if (trackingCode) {
        ReactGA.initialize(trackingCode)
    }

    return trackingCode
}

export default {
    RouteTracker,
    init,
}
